import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
            <div className="container mx-auto px-4 py-8">
                <div className="text-center">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                        Bienvenue sur Globe Processor
                    </h1>
                    <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
                        Simplifiez le traitement de vos fichiers de vente, stocks, PDL, télématique, etc.
                    </p>

                    <div className="flex flex-row gap-4 justify-center">
                        <Link
                            to="/processor"
                            className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg
                                 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600
                                 transition-colors duration-200 text-base font-semibold"
                    >
                        Déposer mes fichiers <span className="font-bold">Sellout</span>
                    </Link>
                    <Link
                        to="/cars-data"
                        className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg
                                 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600
                                 transition-colors duration-200 text-base font-semibold"
                        >
                            Déposer mes fichiers <span className="font-bold">Télématique</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;